/**
 * All the components you'd like to render server-side
 */
module.exports = {
	PlayerHeroModule: require('./Hero/PlayerHero/PlayerHeroModule'),
	MainHeroModule: require('./Hero/MainHero/MainHeroModule'),
	MainNavigationModule: require('./Navigation/MainNavigation/MainNavigationModule'),
	SubNavigationModule: require('./Navigation/SubNavigation/SubNavigationModule'),
	NotificationsModule: require('./Notifications/NotificationsModule'),
	SearchDesktopModule: require('./Search/SearchDesktop/SearchDesktopModule'),
	InPageTabs: require('./Navigation/InPageTabs/InPageTabsModule'),
	FooterSponsorsModule: require('./Footer/Sponsors/FooterSponsorsModule'),
	SiteLinksModule: require('./Footer/SiteLinks/SiteLinksModule'),
	SubscribeModule: require('./Footer/Subscribe/SubscribeModule'),
	SocialLinksModule: require('./Footer/SocialLinks/SocialLinksModule'),
	HygieneLinksModule: require('./Footer/HygieneLinks/HygieneLinksModule'),
	OfficeLocationModule: require('./Footer/OfficeLocation/OfficeLocationModule'),
	ChevronModule: require('./Footer/Chevron/ChevronModule'),
	RawJsonModule: require('../common/RawJson/RawJsonModule'),
	InlineShareModule: require('../common/InlineShare/InlineShareModule'),
	RelatedStoriesModule: require('./RelatedStories/RelatedStoriesModule'),
	GalleryModule: require('./Gallery/GalleryModule'),
	VideoModule: require('./Video/VideoModule'),
	MobileVideoModule: require('./Video/MobileVideoModule'),
	QuoteModule: require('./Quote/QuoteModule'),
	FixtureHeroModule: require('./Hero/FixtureHero/FixtureHeroModule'),
	TrendingHeroModule: require('./Hero/TrendingHero/TrendingHeroModule'),
	CallToActionModule: require('./CallToAction/CallToActionModule'),
	NotFoundModule: require('./NotFound/NotFoundModule'),
	CheckboxModule: require('../common/Checkbox/CheckboxModule'),	
	ServerError: require('./ServerError/ServerErrorModule'),
	PromoBannerModule: require('./PromoBanner/PromoBannerModule'),
	ArchivedBannerModule: require('./ArchivedBanner/ArchivedBannerModule'),
	FixturesListModule: require('./Fixtures/FixturesListModule'),
	FixtureItemModule: require('./Fixtures/FixtureItemModule'),
	PlayersModule: require('./Players/PlayersModule'),
	InfoBannerModule: require('./InfoBanner/InfoBannerModule'),
	ArticleLinkModule: require('./ArticleLink/ArticleLinkModule'),
	MembershipListModule: require('./Membership/MembershipListModule'),
	AdblockBannerModule: require('./AdblockBanner/AdblockBannerModule'),
	MatchDayCentreHeroModule: require('./Hero/MatchDayCentreHero/MatchDayCentreHeroModule'),
	MatchDetailsModule: require('./MDC/MatchDetails/MatchDetailsModule'),
	LiveGameSummaryModule: require('./MDC/LiveGameSummary/LiveGameSummaryModule'),
	TimelineModule: require('./MDC/Timeline/TimelineModule'),
	LiveLeagueTableModule: require('./MDC/LiveResults/LiveLeagueTable/LiveLeagueTableModule'),
	LeagueTableModule: require('./LeagueTable/LeagueTableModule'),
	LiveScoresModule: require('./MDC/LiveResults/LiveScores/LiveScoresModule'),
	LiveResultsModule: require('./MDC/LiveResults/LiveResultsModule'),
	MatchGoalReplayModule: require('./MDC/MatchGoalReplay/MatchGoalReplayModule'),
	MatchChalkboardModule: require('./MDC/MatchChalkboard/MatchChalkboardModule'),
	MatchPassMatrixModule: require('./MDC/MatchPassMatrix/MatchPassMatrixModule'),
	MatchHeatmapModule: require('./MDC/MatchHeatmap/MatchHeatmapModule'),
	MatchAveragePositionsModule: require('./MDC/MatchAveragePositions/MatchAveragePositionsModule'),
	TeamSeasonStatsModule: require('./Team/TeamSeasonStats/TeamSeasonStatsModule'),
	PlayerSeasonStatsModule: require('./Player/PlayerSeasonStats/PlayerSeasonStatsModule'),
	SponsorsMdcModule: require('./MDC/SponsorsMdc/SponsorsMdcModule'),
	LineupModule: require('./MDC/Lineup/LineupModule'),
	SocialTabModule: require('./MDC/SocialTab/SocialTabModule'),
	GoogleMapModule: require('./GoogleMap/GoogleMapModule'),
	CommentaryModule: require('./MDC/Commentary/CommentaryModule'),
	TrendingGridModule: require('./TrendingGrid/TrendingGridModule'),
	TrendingVideoGridModule: require('./TrendingVideoGrid/TrendingVideoGridModule'),
	PossessionStatsModule: require('./MDC/PossessionStats/PossessionStatsModule'),
	SearchResultsModule: require('./SearchResults/SearchResultsModule'),
	SplashScreenModule: require('./SplashScreen/SplashScreenModule'),
	ScrollBackTopModule: require('./Footer/ScrollBackTop/ScrollBackTopModule'),
	SingleImageModule: require('./SingleImage/SingleImageModule'),
	LastFixturePlayerStatsModule: require('./LastFixturePlayerStats/LastFixturePlayerStatsModule'),
	NewsNowModule: require('./NewsNow/NewsNowModule'),
	AsyncModule: require('../common/Async/AsyncModule'),
	SponsorsModule: require('./Sponsors/SponsorsModule'),
	AccessNavigationModule: require('./Navigation/AccessibilityNav/AccessibilityNavModule'),
	DynamicYieldPlaceholderModule: require('./DynamicYieldPlaceholder/DynamicYieldPlaceholderModule'),
	RichTextModule: require('./RichText/RichTextModule'),
	HashtagManagementModule: require('./HashtagModule/HashtagModule'),
	MatchTableModule: require('./MatchTable/MatchTableModule'),
	QuickLinksModule: require('./QuickLinks/QuickLinksModule'),
	WizeBotModule: require('./WizeBot/WizeBotModule'),	
	DotMailerFormModule: require('./DotMailerForm/DotMailerFormModule'),
	GenericEmbedModule: require('./GenericEmbed/GenericEmbedModule'),
	IWCBannerModule: require('./IWCBanner/IWCBannerModule'),
	TicketAvailabilityModule: require('./Membership/TicketAvailabilityModule'),
	IvvyConferenceSignUpForm: require('./IvvyConferenceSignUpForm/IvvyConferenceSignUpForm.scss'),
	PreferenceCentre: require('./PreferenceCentre/PreferenceCentre.scss'),
	HeadlineModule: require('./Headline/Headline'),
	BlockQuoteModule: require('./BlockQuote/BlockQuote'),
	GridGalleryModule: require('./GridGallery/GridGallery'),	
	IntroModule: require('./Intro/Intro'),	
	MediaHeroModule: require('./MediaHero/MediaHero'),	
	ImageCopyModule: require('./ImageCopy/ImageCopy'),	
	ImageCopyAccordionModule: require('./ImageCopy/ImageCopyAccordion'),	
	TaglineAndTextBlocksModule: require('./TaglineText/TaglineText'),	
	FeaturesModule: require('./Features/Features'),
	ListingCards: require('./ListingCards/ListingCards'),
	KeyFactsModule: require('./KeyFacts/KeyFacts'),
	BookingCTAModule: require('./Cta/Cta'),
	InformationModule: require('./Information/InformationModule'),
	ListingCardFiltersModule: require('./ListingCardFilters/ListingCardFilters'),
	CustomCTAModule: require('./CustomCta/Cta'),
	HashChangeModule: require('./HashChange/HashChangeModule'),
	SupportersClubSearchModule: require('./SupportersClub/Search'),
	SupportersClubsMapModule: require('./SupportersClubsMap/SupportersClubsMapModule'),
	ImageBannerModule: require('./ImageBanner/ImageBanner'),
	MemberBenefitsModule: require('./MemberBenefits/MemberBenefits'),
	TestimonialCarousel: require('./TestimonialCarousel/TestimonialCarouselModule'),
	VideoModuleOneHotspur: require('./Video/VideoModuleOneHotspur'),
	QualifioFormModule: require('./QualifioForm/QualifioFormModule'),
	AlgoliaSearchModule: require('./AlgoliaSearch/AlgoliaSearchModule'),
	Dialog: require('./Dialog/Dialog'),
	VideoMemberModal: require('./VideoMemberModal/VideoMemberModal'),
	MemberWeekVoucher: require('./MemberWeekVoucher/MemberWeekVoucher'),
	VoucherCode: require('./VoucherCode/VoucherCode'),
	AdultJuniorBenefitsModule: require('./AdultJuniorBenefits/AdultJuniorBenefitsModule'),
	BenefitsTableModule: require('./MemberBenefitsTable/MemberBenefitsTableModule'),
	DeviceCheck: require('../common/DeviceCheck/DeviceCheck')
};




//////////////////
// WEBPACK FOOTER
// ./~/eslint-loader?{}!./src/components/index.js
// module id = 484
// module chunks = 0